var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHeight = function SvgIconHeight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M6 7C4.3 7 3 5.7 3 4h0c0-1.7 1.3-3 3-3h0c1.7 0 3 1.3 3 3h0c0 1.7-1.3 3-3 3m2 16H4v-4l-2-3v-6h8v6l-2 3zm7-17h3m-3 4h2m-2 4h3m-3 4h2M15 1h7v22h-7z"
  }))));
};
export { SvgIconHeight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTAgMGgyNHYyNEgweiIvPgogICAgICAgIDxnIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiPgogICAgICAgICAgICA8cGF0aCBkPSJNNiA3aDBDNC4zIDcgMyA1LjcgMyA0aDBjMC0xLjcgMS4zLTMgMy0zaDBjMS43IDAgMyAxLjMgMyAzaDBjMCAxLjctMS4zIDMtMyAzek04IDIzSDR2LTRsLTItM3YtNmg4djZsLTIgM3pNMTUgNmgzTTE1IDEwaDJNMTUgMTRoM00xNSAxOGgyTTE1IDFoN3YyMmgtN3oiLz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";